import type * as React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

import {
    createInteractiveComponent,
    type InteractiveComponent,
} from './createInteractiveComponent';
import { createInteractiveHandle } from './handles';
import { useInteractiveComponent } from './useInteractiveComponent';
import { useInteractiveState, WithInteractiveState } from './useInteractiveState';

/**
 * The `Interactive` API is designed to concisely express a interactive pattern in a performant way.
 */
export const Interactive = {
    /** Create a handle to connect multiple view to one view interactive state. */
    createInteractiveHandle,
    /** Listen to the interaction on an element. */
    useInteractiveState,
    WithInteractiveState,
    /** Make any React component Responsive. Used to create Responsive.View, etc. */
    createInteractiveComponent,
    useInteractiveComponent,
    isInteractiveComponent,
    /**
     * Interactive variants of the basic native View.
     */
    View: createInteractiveComponent(View),
    /**
     * Interactive variants of the basic native Text.
     */
    Text: createInteractiveComponent(Text),
    /**
     * Interactive variants of the basic native TouchableOpacity.
     */
    TouchableOpacity: createInteractiveComponent(TouchableOpacity),
};

/**
 * Type predicate to check if a component is an interactive component.
 */
function isInteractiveComponent<C extends React.ElementType = React.ElementType>(
    component: C
    // @ts-ignore
): component is InteractiveComponent<C> {
    // @ts-ignore
    return !!component.isInteractive;
}
